import React, { useEffect, useState } from "react";
import { FaPlus, FaUserDoctor } from "react-icons/fa6";
import { IoClose } from "react-icons/io5";
import { LiaHandsHelpingSolid, LiaHireAHelper } from "react-icons/lia";
import { MdEdit } from "react-icons/md";
import { RxUpdate } from "react-icons/rx";
import TypeOfHelpModal from "../../Modal/SurgeryModal/TypeOfHelpModal";
import { useDispatch, useSelector } from "react-redux";
import {
  getTypeOfHeAction,
  updateTypeOfHelpAction,
} from "../../Actions/SurgeryAction/TypeOfHelpAction";
import { BsInputCursorText } from "react-icons/bs";
import TypeFieldModal from "../../Modal/TypeFieldModal/TypeFieldModal";
import { IoMdEye } from "react-icons/io";
import { useNavigate } from "react-router-dom";

const TypeOfHelp = () => {
  const [typeOfHelp, setTypeOfHelp] = useState(null);
  const [debounceValue, setDebounceValue] = useState(null);
  const navigate = useNavigate();
  const [indexx, setIndexx] = useState(null);
  const dispatch = useDispatch();
  const [inputValue, setInputValue] = useState({
    name: "",
    id: "",
  });
  useEffect(() => {
    dispatch(getTypeOfHeAction(debounceValue));
  }, [debounceValue]);
  const handleEdit = (id, name, index) => {
    setIndexx(index);
    setInputValue({
      ...inputValue,
      name: name,
      id: id,
    });
  };
  const handleClose = () => {
    setIndexx(null);
  };
  const handleUpdate = () => {
    dispatch(updateTypeOfHelpAction(inputValue.id, inputValue.name));
    setIndexx(null);
  };
  const [isOpenModal, setIsOpenModal] = useState(false);
  const getTypeOfHelp = useSelector((state) => state.getTypeOfHelp);
  const { typeOfHelps } = getTypeOfHelp;
  const [isOpenFieldModal, setIsOpenFieldModal] = useState(false);
  const [id, setId] = useState(null);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebounceValue(typeOfHelp);
    }, 1000); 
    return () => {
      clearTimeout(handler);
    };
  }, [typeOfHelp]);
  return (
    <div className="parent">
      <div className="flex justify-between gap-2 px-2 items-center">
        <div className="flex gap-1 items-center font-bold text-blue-600">
          <LiaHireAHelper />

          <p>Type Of Help</p>
        </div>
        <div className="mt-1">
          <button
            className="btn-primary flex gap-2 items-center"
            onClick={() => setIsOpenModal(true)}
          >
            <p>Add Type Help</p>
            <FaPlus />
          </button>
        </div>
      </div>
      <div className="w-5/12 m-auto">
        <input
          type="text"
          className="input w-full"
          placeholder="Search By Type Of Help Name"
          value={typeOfHelp}
          onChange={(e) => setTypeOfHelp(e.target.value)}
        />
      </div>
      <div className="parent-table">
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {typeOfHelps?.map((type, index) => {
              return (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td className="w-[55%]">
                    {indexx == index ? (
                      <input
                        type="text"
                        className="input w-full"
                        placeholder="Name"
                        onChange={(e) => {
                          setInputValue({
                            ...inputValue,
                            name: e.target.value,
                          });
                        }}
                        value={inputValue.name}
                      />
                    ) : (
                      type.name
                    )}
                  </td>
                  <td>
                    {indexx == index ? (
                      <div className="flex gap-2  items-center">
                        <button
                          onClick={handleUpdate}
                          className="btn-primary flex gap-2 items-center"
                        >
                          Update <RxUpdate />
                        </button>
                        <button
                          onClick={handleClose}
                          className="btn-danger flex gap-2 items-center"
                        >
                          Close <IoClose />{" "}
                        </button>
                      </div>
                    ) : (
                      <div className="flex items-center gap-2">
                        <button
                          onClick={() => handleEdit(type.id, type.name, index)}
                          className="btn-warning   flex items-center gap-2"
                        >
                          Edit <MdEdit />
                        </button>
                        <button
                          onClick={() => navigate("/type/field/" + type.id)}
                          className="btn-primary   flex items-center gap-2"
                        >
                          View Field <IoMdEye />
                        </button>
                        <button
                          onClick={() => {
                            setIsOpenFieldModal(true);
                            setId(type.id);
                          }}
                          className="btn-info   flex items-center gap-2"
                        >
                          Add Field <BsInputCursorText />
                        </button>
                      </div>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {isOpenModal && (
        <TypeOfHelpModal closeModal={() => setIsOpenModal(false)} />
      )}
      {isOpenFieldModal && (
        <TypeFieldModal id={id} closeModal={() => setIsOpenFieldModal(false)} />
      )}
      <div className="pb-10"></div>
    </div>
  );
};

export default TypeOfHelp;
